import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageTitle from '../../../../components/common/page-title';
import SubmissionsTable from '../../../../components/admin/submissions/list/submissions-table';
import SubmissionSearch from '../../../../components/admin/submissions/list/submissions-search';
import ConfirmPopup from '../../../../components/common/confirm-popup';
import { getSubmissions, updateSubmissionsStatus } from '../../../../actions/submissions';

class SubmissionsPage extends Component {
  state = {
    outletCode: '',
    submissionType: '',
    postcodePlanObjectiveId: '',
    status: '',
    dateFrom: '',
    dateTo: '',
    auditCompleted: '',
    page: 1,
    isValidateStatusPopupOpen: false,
    isDeclineStatusPopupOpen: false,
    checkedSubmissions: {},
    auditorUser: ''
  };

  componentWillMount() {
    const { dispatch, isAbm, isAuditor } = this.props;
    let status;

    if (isAbm) {
      status = 'PRE-VALIDATED';
    } else if (isAuditor) {
      status = 'PENDING';
    }

    this.setState({ status });
    dispatch(getSubmissions(null, status));
  }

  handleOutletCodeChange = (e) => {
    this.setState({ outletCode: e.target.value });
  };

  handleDateFromChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ dateFrom: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ dateFrom: '' });
    }
  };

  handleDateToChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ dateTo: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ dateTo: '' });
    }
  };

  handleAuditCompletedChange = (event) => {
    this.setState({ auditCompleted: event.target.value });
  };

  handleTypeChange = (event) => {
    this.setState({ submissionType: event.target.value });
  };

  handlePostcodeplanObjectiveChange = (event) => {
    this.setState({ postcodePlanObjectiveId: event.target.value });
  };

  handleStatusChange = (event) => {
    this.setState({ status: event.target.value });
  };

  handleAuditorUserChange = (event) => {
    this.setState({ auditorUser: event.target.value });
  }

  handleSearch = () => {
    const { dispatch } = this.props;
    const {
      outletCode, dateFrom, dateTo, auditCompleted,
      status, page, submissionType, postcodePlanObjectiveId, auditorUser
    } = this.state;

    dispatch(getSubmissions(
      outletCode,
      status,
      dateFrom,
      dateTo,
      auditCompleted,
      page,
      submissionType,
      postcodePlanObjectiveId,
      auditorUser
    ));
  };

  handleSearchButton = () => {
    this.setState({ page: 1 }, this.handleSearch);
  };

  handlePageChange = (page) => {
    this.setState({ page }, this.handleSearch);
  };

  handleClear = () => {
    this.setState({
      outletCode: '',
      status: '',
      dateFrom: '',
      dateTo: '',
      postcodePlanObjectiveId: '',
      submissionType: '',
      auditCompleted: '',
      auditorUser: ''
    }, this.handleSearch);
  };

  handleValidateAllChecked = () => {
    this.setState({ isValidateStatusPopupOpen: true });
  };

  handleDeclineAllChecked = () => {
    this.setState({ isDeclineStatusPopupOpen: true });
  };

  handleClose = (isConfirm) => {
    if (isConfirm) {
      const { dispatch } = this.props;
      const { checkedSubmissions, isValidateStatusPopupOpen, isDeclineStatusPopupOpen } = this.state;
      const submissionIds = [];

      Object.entries(checkedSubmissions).forEach(([key, value]) => {
        if (value) {
          submissionIds.push(+key);
        }
      });

      if (isValidateStatusPopupOpen) {
        dispatch(updateSubmissionsStatus('validated', { submission_ids: submissionIds }));
        this.setState({ isValidateStatusPopupOpen: false });
      } else if (isDeclineStatusPopupOpen) {
        dispatch(updateSubmissionsStatus('declined', { submission_ids: submissionIds }));
        this.setState({ isDeclineStatusPopupOpen: false });
      }
    } else {
      this.setState({ isValidateStatusPopupOpen: false, isDeclineStatusPopupOpen: false });
    }
  };

  handleCheckboxClick = (id) => {
    const { checkedSubmissions } = this.state;
    const isChecked = checkedSubmissions[id];

    this.setState({ checkedSubmissions: { ...checkedSubmissions, [id]: !isChecked } });
  };

  render() {
    const {
      paging, meta, loading, submissions, isAbm
    } = this.props;
    const {
      page, status, dateFrom, dateTo, submissionType, postcodePlanObjectiveId,
      auditCompleted, outletCode, isValidateStatusPopupOpen, isDeclineStatusPopupOpen, auditorUser
    } = this.state;

    const pageTitle = isAbm ? 'Price It Plus Submissions' : 'Submissions';

    return (
      <div>
        <PageTitle>{pageTitle}</PageTitle>
        {loading ? 'Loading...' : (
          <div>
            <SubmissionSearch
              postcodePlanObjectiveId={postcodePlanObjectiveId}
              submissionType={submissionType}
              status={status}
              statusTypes={meta['status-types']}
              dateFromValue={dateFrom}
              dateToValue={dateTo}
              auditCompleted={auditCompleted}
              outletCode={outletCode}
              postCodeplanObjectives={meta['postcodeplan-objectives']}
              auditorUser = {auditorUser}
              auditorUsers={meta['auditor-users']}
              onTypeChange={this.handleTypeChange}
              onPostcodeplanObjectiveChange={this.handlePostcodeplanObjectiveChange}
              onStatusChange={this.handleStatusChange}
              onDateFromChange={this.handleDateFromChange}
              onDateToChange={this.handleDateToChange}
              onAuditCompletedChange={this.handleAuditCompletedChange}
              onOutletCodeChange={this.handleOutletCodeChange}
              onSearch={this.handleSearchButton}
              onClear={this.handleClear}
              onValidateAllChecked={this.handleValidateAllChecked}
              onDeclineAllChecked={this.handleDeclineAllChecked}
              onAuditUserChange={this.handleAuditorUserChange}
              pendings={meta['pending-count']}
            />
            <SubmissionsTable
              submissions={submissions}
              currentPage={page}
              onPageChange={this.handlePageChange}
              onCheckboxClick={this.handleCheckboxClick}
              paging={paging}
            />
            {(isValidateStatusPopupOpen || isDeclineStatusPopupOpen) && (
              <ConfirmPopup header="Update submission status" onClose={this.handleClose}>
                Are you sure you want to update the status of the selected submissions?
                Once you have changed the status, this cannot be reverted.
              </ConfirmPopup>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  submissions: state.submissions.submissions,
  loading: !state.submissions.fetched && state.submissions.fetching,
  meta: state.submissions.meta,
  paging: state.submissions.paging,
  isAbm: state.viewConfig.profile.attributes['user-group'] === 'abm',
  isAuditor: state.viewConfig.profile.attributes['user-group'] === 'savi_auditor'
});

export default connect(mapStateToProps)(SubmissionsPage);



// WEBPACK FOOTER //
// ./src/components/admin/submissions/list/submissions-page.jsx